import React, { useState, useEffect, useRef} from "react";
import {
  EditPageContainer,
  Page,
  withServerErrors,
} from "components/common";
import {
  FormGroup,
  BackButton,
} from "components/common/Forms";
import { compose, withState } from "recompose";
import { get } from 'lodash';
import { LocalForm, Control } from "react-redux-form";
import GetBack from "components/refactoring/BackButton";
import { Trans, useTranslation } from "react-i18next";
import { Row, Col, Button, ButtonGroup, ButtonToolbar } from "reactstrap";
import { NotificationManager } from "react-notifications";
import withReload from "../../components/common/withReload";
import { useHistory, useLocation } from "react-router-dom";
import PermissionTable from "./PermissionTable";
import AccessPermissions from "./AccessPermissions"
import LoadingMsg from "components/common/LoadingMsg";
import { isNumericString } from "services/util";
import { useOrganisationContext } from "hooks";

export const getOutlineStyle = (color, size, border) => ({
  border: `${border || "1px"} solid ${color}`,
  color: color,
  padding: '0.25rem 0.5rem',
  borderRadius: '0.2rem',
  fontSize: size
});

export const UserEdit = ({
  onBack,
  setDispatch,
  onUpdate,
  onChange,
  readOnly,
  client,
  reload,
  match,
}) => {

  const { t, i18n } = useTranslation();
  const { selectedOrganisation, } = useOrganisationContext();

  const [permissionOptions, setPermissionOptions] = useState([]);
  const [item, setItem] = useState(null)
  const [user_organisation_permissions, setPermissions] = useState();
  const [resendWait, setWait] = useState(false);
  const [groupOptions, setGroupOptions] = useState();
  const [groupLoading, setGroupLoading] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const [displayedGroup, setDisplayedGroup] = useState();
  const [showModal, setShowModal] = useState(false);
  
  const history = useHistory();

  const HandlePost = (data) => { 
    let itemx = { ...data, user_organisation_permissions: user_organisation_permissions, groups: [displayedGroup], connected_organisation: selectedOrganisation?.id }

    if ("get_activation_link" in itemx) {
      delete item.get_activation_link;
    }

    if (!itemx.first_name || !itemx.last_name || !itemx.email) {
      NotificationManager.error(t('Please make sure you have entered first name, last name and email.'));
      return
    }

    if (user_organisation_permissions?.length === 0) {
      NotificationManager.error(t('Please make sure you are selecting permissions.'));
      return ;
    }

    if (!displayedGroup) {
      NotificationManager.error(t("Please select a Group"))
      return
    }


    let endpoint = isNumericString(match.params.id) ? `/${match.params.id}` : ''
    let method = isNumericString(match.params.id) ? "put" : "post";
    
    client[method](`/authorization/${selectedOrganisation.id}/company_user${endpoint}`,itemx)
      .then(({ data }) => {
        if (method === 'post') {
          NotificationManager.success(t('User Invited Successfully.'));
          history.push(`/userslist/${data.id}`);
        } else {
          NotificationManager.success(t('User Updated Successfully.'));
          setTimeout(() => {
            reload();
          }, 1000);
        }
      })
      .catch((error) => {
        if (error.response) {
          const responseData = error.response.data;

          if (responseData.code === 'invalid') {
            if (responseData.email) {
              NotificationManager.error(responseData.email[0]);
            }
            if (responseData.groups) {
              NotificationManager.error(responseData.groups[0] === 'Invalid pk "None" - object does not exist.' ?
                t('Please select a group role') : responseData.groups[0]);
            }
          } else if (responseData.message) {
            NotificationManager.error(responseData.message);
          } else {
            NotificationManager.error(responseData[0] || t('Error at updating, please check the details.'));
          }
        } else if (error.request) {
          NotificationManager.error(t('No response from the server'));
        } else {
          console.error('Error during request setup:', error.message);
          NotificationManager.error(t('Error at updating'));
        }
      });
  }

  useEffect(() => {
    client.get("/authorization/permission")
      .then((response) => {
        setPermissionOptions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching permission options:", error);
      });
  }, []);


  useEffect(() => {
    const fetchGroupOptions = async () => {
      setGroupLoading(true)
      try {
        const response = await client.get("/authorization/group");
        setGroupOptions(response.data);
        setGroupLoading(false)
      } catch (error) {
        console.error("Error fetching group options:", error);
        setGroupLoading(false)
      }
    };

    fetchGroupOptions();
  }, []);

  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const fetchUser = async (params) => {
      try {
        if(match.params.id !== 'new'){
          const response = await client.get(`/authorization/${selectedOrganisation.id}/company_user/${match.params.id}`);
          setItem(response.data)
          setPermissions(response.data? response.data.user_organisation_permissions:[])
          setDisplayedGroup(response.data? response.data.groups?.[0]:null)
        }else{
          setItem({
            email: urlSearchParams.get("email") || item?.email,
            first_name: urlSearchParams.get("first_name") || item?.first_name,
            last_name: urlSearchParams.get("last_name") || item?.last_name,
            contact_number: urlSearchParams.get("contact_number") || item?.contact_number,
          })
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
    }
    fetchUser()
}, [, match.params.id]);

  const handleInviteClick = async (item) => {
    const email = item.email;
    const lang = i18n?.language || "en";

    const postData = { email, lang, connected_organisation: selectedOrganisation?.id };

    try {
      setWait(true); 

      await client.post('authorization/resend_email', postData);
      NotificationManager.success("Invite resend successful");
    } catch (ex) {
      const responseData = get(ex, 'response.data') || {};

      Object.keys(responseData).forEach((key) => {
        const errorMessage = responseData[key];
        if (errorMessage) {
          NotificationManager.error(errorMessage);
        }
      });
    } finally {
      setWait(false); 
    }
  };

  const [showLink, setShowLink] = useState(false);

  const copyInviteLink = () => {
    try {
      navigator.clipboard.writeText(item.invitation_link);
      NotificationManager.success('Invite link copied to clipboard');
      setShowLink(true);
    } catch (error) {
      NotificationManager.error('Failed to copy invite link');
    } finally {
    }
  };

  const closeMessage = () => {
    setShowLink(false);
  };

  
  const onSelect = (id) => {
    if (selectedGroup === id) {
      setSelectedGroup(null)
      setDisplayedGroup(null)
    } else {
      setSelectedGroup(id)
      setDisplayedGroup(id)
    }
  };


  const currentUrl = window.location.href;
  const isNew = /new/.test(currentUrl);

  const titleChange = isNew ?  "Invite New User" : `Edit User`;

  const colStyle = {
    xs: false,
    md: 6,
    className: "pt-1 pb-1"
  }


  const handleClose = () => {
    setShowModal(false);
  };

  if(!item)
    return null

    
    return (
      <Page title={titleChange}>
        <div className="mx-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <GetBack styleClass="my-2"/>
          {!isNew &&
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {item && !item.is_active ? (
                <>
                <button
                  className={`btn btn-outline-secondary btn-sm mr-0 ${resendWait ? 'disabled' : ''}`}
                  onClick={() => !resendWait && handleInviteClick(item)}>
                  {resendWait ? t('Loading...') : <Trans>Re-send Invite</Trans>}
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {copyInviteLink()}}>
                  <Trans>Copy Invite Link</Trans>
                </button>
                <span style={getOutlineStyle('#72B566')}><Trans>User Invited</Trans></span>
                </>
              ) : (
                <>
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => setShowModal(true)}>
                  <Trans>Manage Access</Trans>
                </button>
                <span style={getOutlineStyle('#72B566')}><Trans>User Active</Trans></span>
                <AccessPermissions show={showModal} handleClose={handleClose} userID={item.id} details={item}/>
                </>
              )}
            </div>
          }
        </div>
        {showLink &&       
        <div className="alert alert-info fade show my-3" role="alert">
          <ul className="mb-0 pl-3 text-center">
          <li>
            <strong style={{fontSize: "1.1em"}}><Trans>Invite Link:</Trans></strong> {item.invitation_link}
            <button type="button" className="close" onClick={() => { closeMessage() }} style={{ color: '#153385' }}>
              <span aria-hidden="true">&times;</span>
            </button>
          </li>
          </ul>
        </div>
        }
        <LocalForm
          initialState={item}
          onSubmit={values => HandlePost(values)}
        >
          <Row className="mb-1">
            <Col {...colStyle}>
              <FormGroup label="First Name*" model=".first_name">
                <Control.text model=".first_name" required disabled={readOnly} />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label="Last Name*"  model=".last_name">
                <Control.text model=".last_name" required disabled={readOnly} />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label="Email*"  model=".email">
                <Control.text model=".email" required disabled={readOnly} />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label="Contact Number*"model=".contact_number">
                <Control.text model=".contact_number"/>
            </FormGroup>
            </Col>
          </Row>
          <FormGroup label="Select a Group">
            <ButtonToolbar size="sm" className="mt-3">
              {!groupLoading ? (
                groupOptions?.length > 0 ? (
                  groupOptions.map((group, index) => (
                    <Button
                      key={group.id}
                      color={displayedGroup === group.id ? "primary" : "secondary"}
                      //style={selectedGroup === group.id ? buttonS.active : buttonS.inactive}
                      size="sm"
                      onClick={() => onSelect(group.id)}>
                      {t(group.name)}
                    </Button>
                  ))
                ) : (
                  <div className="m-2"><Trans>No Groups available - Please Contact Admin</Trans></div>
                )
              ) : (
                <div className="mb-0 form-text text-muted small"><LoadingMsg message="Groups Loading"/></div>
              )}
            </ButtonToolbar>
          </FormGroup>
          {isNew && <div className="d-flex align-items-center my-3">
            <input type="checkbox" checked={true} disabled/><span className="ml-2"><Trans>Invite to Accounting</Trans></span>
          </div>}
          <div className="tw-flex my-3">
            <FormGroup className="my-3 d-flex justify-content-end">
              <BackButton className="mr-2 ml-0" onClick={onBack}/>
              <Button className={`btn btn-outline-success`}> <Trans>Save</Trans> </Button>
            </FormGroup>
          </div>
          <div className="my-3"> 
          <FormGroup label="Permissions:"/>
          <PermissionTable
            permissionOptions={permissionOptions}
            onPermissionChange={setPermissions}
            parentPermissions={user_organisation_permissions || []}
            selectedGroup={selectedGroup}
          />
        </div>
        </LocalForm>
      </Page>
    );
  };

  
  export default UserEdit;
